import { Bridge } from 'src/utils/bridge'
import { useChannel } from 'src/provider/ChannelContextProvider'
import { useCookies } from 'react-cookie'
import usePageNav from 'src/hooks/usePageNav.hook'
import {
  passCertResponseQueryOption,
  useCustomMutation,
} from 'src/hooks/react-query/useCustomMutation.hook'
import {
  PassCertCheckSpace,
  PassCertResponseSpace,
  PassReqType,
  ResponseDataType,
} from 'src/types/api'
import { ERRCODE_SUCCESS } from 'src/service/constant/errcodes'
import { useModal } from 'src/provider/ModalContextProvider'
import { passCertCheckQueryOption, useCustomQuery } from 'src/hooks/react-query/useCustomQuery.hook'
import { useLocation } from 'react-router-dom'

const usePassCert = (uuid: string) => {
  const { pathname } = useLocation()
  const { channel, aos } = useChannel()
  const [cookies, setCookie, removeCookie] = useCookies(['req_num'])
  const { passFormPageNav } = usePageNav()
  const { openModal } = useModal()

  const reqNum = cookies['req_num'] ?? uuid
  const isGiftcard = pathname.includes('/giftcard')

  const { mutateAsync: passCertResponseMutate } = useCustomMutation<
    PassCertResponseSpace.Request,
    PassCertResponseSpace.Response
  >(passCertResponseQueryOption())

  const {
    data: passCertCheckQueryData,
    isLoading: isPassCertCheckLoading,
    refetch: passCertCheckRefetch,
  } = useCustomQuery<PassCertCheckSpace.Response>(passCertCheckQueryOption(!isGiftcard))

  const isPassCert = passCertCheckQueryData?.Body?.Result === 'Y'

  const passCertRequest = (type: PassReqType, internalOpen?: boolean) => {
    if (aos || !!internalOpen) {
      setCookie('req_num', uuid, { path: '/' })
      passFormPageNav(type, uuid)
    } else {
      const externalUrl = `${window.location.origin}/${channel}/pass/${type}/${uuid}`
      Bridge.handleReqExternalOpenUrl(externalUrl)
    }
  }

  const passCertResponse = (
    type: PassReqType,
    successFn?: (res: ResponseDataType<PassCertResponseSpace.Response>) => void,
    failFn?: (res: ResponseDataType<PassCertResponseSpace.Response>) => void,
  ) => {
    !!reqNum &&
      passCertResponseMutate({ ReqNum: reqNum, Type: type }).then(
        (res: ResponseDataType<PassCertResponseSpace.Response>) => {
          const { Body, Header } = res
          const { Result, Name } = Body
          if (res.Header.ErrCode !== ERRCODE_SUCCESS) {
            failFn?.(res)
            openModal({ contents: { d: Header.ErrMsg }, button: { submit: { t: '닫기' } } })
          } else if (Result === 'Y') {
            if (type === 0) {
              Bridge.handleReqSaveName(Name)
              passCertCheckRefetch?.()
            }
            successFn?.(res)
          }
          removeCookie('req_num', { path: '/' })
        },
      )
  }

  return {
    reqNum,
    passCertRequest,
    passCertResponse,
    isPassCert,
    isPassCertCheckLoading,
  }
}

export default usePassCert
